import notice from './notice.vue'
import titleMargin from './title_margin.vue'
import emptyTips from './empty_tips.vue'

export {
  notice,
  titleMargin,
  emptyTips
}



// WEBPACK FOOTER //
// ./src/widgets/basic_plugin_code/components/index.js